import { PaymentService } from '$services/payment/payment.service'
import { Payment, PostDisplay, PaymentInfo } from '$types'
import { Component, OnDestroy, OnInit, Input, Output, EventEmitter } from '@angular/core'
import { FormBuilder, FormGroup } from '@angular/forms'
import { MatSnackBar } from '@angular/material/snack-bar'
import { ActivatedRoute } from '@angular/router'
import { mergeMap, Subscription } from 'rxjs'
import { PostsService } from '$services/posts/posts.service';

interface Params {
  [key: string]: string;
}

@Component({
  selector: 'app-payment-button',
  templateUrl: './payment-button.component.html',
  styleUrls: ['./payment-button.component.css'],
})
export class PaymentButtonComponent implements OnInit, OnDestroy {

  @Input() renew: boolean = false
  @Output() onPayment = new EventEmitter<PaymentInfo>();
  paymentInfo: PaymentInfo = { montant: 0, nomCheval: '' };
  postDisplay!: PostDisplay;

  constructor(
    private readonly snackBar: MatSnackBar,
    private readonly formBuilder: FormBuilder,
    private readonly paymentService: PaymentService,
    private readonly route: ActivatedRoute,
    private readonly postsService: PostsService,
  ) { }

  paymentForm!: FormGroup
  paymentSubscription$: Subscription | null = null
  isLoaded: boolean = false

  get data() {
    return this.paymentForm.get('data')
  }

  get interfaceVersion() {
    return this.paymentForm.get('interfaceVersion')
  }

  get seal() {
    return this.paymentForm.get('seal')
  }

  get url() {
    return this.paymentForm.get('url')
  }
  ngOnInit(): void {
    let id_post: string
    this.paymentForm = this.formBuilder.group({
      data: [''],
      interfaceVersion: [''],
      seal: [''],
      url: [''],
    })
    this.paymentSubscription$ = this.route.queryParams
      .pipe(
        mergeMap((params) => {
          id_post = params['id']
          if (this.renew) {
            return this.paymentService.getSherlockRenewal(id_post)
          } else {
            return this.paymentService.getSherlockPayment(id_post)
          }
        })
      )
      .subscribe({
        next:

          (paymentData: Payment) => {
            this.data?.setValue(paymentData.data)
            this.paymentInfo.montant = this.getAmount(this.parsePaymentParams(this.data?.value))
            this.seal?.setValue(paymentData.seal)
            this.interfaceVersion?.setValue(paymentData.interfaceVersion)
            this.url?.setValue(paymentData.url)
            this.isLoaded = true
            if (id_post !== undefined && id_post !== null) {
              this.postsService.findById(id_post).subscribe((post: PostDisplay) => {
                this.paymentInfo.nomCheval = post.horse.name
                this.makePayment()
                this.postDisplay = post;
              })
            }
          },


        error: (err) => {
            if(err.status === 400){

              this.snackBar.open('⚠ : ' + err.error.message, 'x', {
                duration: 5000,
                verticalPosition: 'top',
                panelClass: ['bg-orange'],
              });
            }
            else {

              this.snackBar.open('⚠ : une erreur est survenue', 'x', {
                duration: 5000,
                verticalPosition: 'top',
                panelClass: ['bg-red'],
              });
            }
        },
      })
  }

  ngOnDestroy(): void {
    this.paymentSubscription$ && this.paymentSubscription$.unsubscribe()
  }

  submit(event: SubmitEvent) {
    const form = event.target as HTMLFormElement
    form.action = this.url?.value
    form.submit()
  }

  parsePaymentParams(paramsString: string): any {
    const params: Params = {};
    const pairs = paramsString.split('|');

    for (let i = 0; i < pairs.length; i++) {
      const pair = pairs[i].split('=');
      params[pair[0]] = pair[1];
    }

    return params;
  }

  getAmount(paramsString: any): number {
    if (paramsString?.amount && typeof paramsString?.amount === 'string') {
        return parseInt(paramsString?.amount, 10)/100;
      }
    return 0
  }


  makePayment() {
    const paymentInfo = {
      montant: this.paymentInfo.montant,
      nomCheval: this.paymentInfo.nomCheval,
    };
    this.onPayment.emit(paymentInfo);
  }
}
